import { useSite } from "../../context/SiteContext";
import { EVENT_START } from "../../lib/core";
import { InlineCountdown } from "./Countdown";
import { Container } from "./ui";

export const TopBar = () => {
  const show = Date.now() < EVENT_START;
  return (
    <div data-testid="top-bar" className="sticky top-0 z-50 border-b border-[#D4AF37]/60 bg-[#0A0A0A]/95 backdrop-blur">
      <div className="mx-auto flex h-[43px] max-w-6xl items-center justify-center overflow-hidden whitespace-nowrap px-3 text-[12px] font-medium text-[#E8D9A8] sm:text-[13px]">
        <span className="md:hidden">
          15 Nov · Whitefield{show && <> · Summit starts in <InlineCountdown short target={EVENT_START} testid="top-bar-countdown-mobile" /></>}
        </span>
        <span className="hidden md:inline">
          <strong className="font-bold text-[#F5D77A]">Wealth Code Summit</strong> • Sun, 15 Nov 2026 • Sheraton Grand, Whitefield
          {show && <> • Summit starts in <InlineCountdown target={EVENT_START} testid="top-bar-countdown" /></>}
        </span>
      </div>
    </div>
  );
};

export const Header = () => {
  const { scrollTo } = useSite();
  return (
    <Container className="relative z-10 hidden items-center justify-end py-4 sm:py-5 md:flex">
      <button
        type="button"
        data-testid="header-book-button"
        onClick={() => scrollTo("pricing")}
        className="btn-ghost-gold rounded-full px-5 py-2.5 text-xs font-bold uppercase tracking-[0.18em]"
      >
        Tickets
      </button>
    </Container>
  );
};
